import { render, staticRenderFns } from "./PrazoEntregaPaises.vue?vue&type=template&id=62de51a2"
import script from "./PrazoEntregaPaises.vue?vue&type=script&lang=js"
export * from "./PrazoEntregaPaises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports